/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Bypass_Dialogue_LabelInputs */



/**
* | output |
* | --- |
* | "Bypass dialogue" |
*
* @param {Ad_Bypass_Dialogue_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_bypass_dialogue_label = /** @type {((inputs?: Ad_Bypass_Dialogue_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Bypass_Dialogue_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contourner le dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialog überspringen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Bypassare il dialogo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обход диалога")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diálogo de omisión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("绕过对话框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダイアログをバイパス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाईपास संवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ignorar diálogo")
	return /** @type {LocalizedString} */ ("Bypass dialogue")
});